module.exports = __webpack_public_path__ + "static/sprintly-0c6f3e53f87d3bd042b2e8cf7f45a92f.png";